import backgroundUrl from '@/assets/login-background.svg'
import bracketUrl from '@/assets/login-bracket.svg'
import bracketDarkUrl from '@/assets/login-bracket-dark.svg'
import { cn } from '@/lib/utils'

function BracketHalf({ className }: { className?: string }) {
  const base = 'absolute top-0 h-full w-[141px]'
  return (
    <>
      <img src={bracketUrl} alt="" className={cn(base, 'dark:hidden', className)} />
      <img src={bracketDarkUrl} alt="" className={cn(base, 'hidden dark:block', className)} />
    </>
  )
}

export function LoginBrandPanel({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      data-testid="login-brand-panel"
      className={cn('relative overflow-hidden rounded-2xl bg-[rgb(212_212_218/0.2)]', className)}
    >
      <div className="absolute left-[-51.73%] top-[-65.47%] h-[162.2%] w-[203.35%]">
        <div className="absolute inset-[-22.11%_-18.63%_-6.32%_-12.93%]">
          <img src={backgroundUrl} alt="" className="block size-full max-w-none" />
        </div>
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative h-[278px] w-[354px]">
          <BracketHalf className="left-0" />
          <div className="absolute left-[142px] top-[104px] size-[70px] rotate-[31deg] rounded-[5px] bg-page" />
          <BracketHalf className="left-[213px] -scale-x-100" />
        </div>
      </div>
    </div>
  )
}
